function clampByte(n) {
    return Math.max(0, Math.min(255, Math.round(n)));
}
function normalizeHex(hex) {
    const v = hex.trim();
    if (!v.startsWith('#'))
        return `#${v}`;
    return v;
}
function hexToRgb(hex) {
    const v = normalizeHex(hex);
    const r = parseInt(v.slice(1, 3), 16);
    const g = parseInt(v.slice(3, 5), 16);
    const b = parseInt(v.slice(5, 7), 16);
    return { r, g, b };
}
/**
 * Alpha blend a foreground hex color over a background hex color.
 * Returns an opaque CSS `rgb(r, g, b)` string.
 */
export function alphaBlendHex(foregroundHex, alpha, backgroundHex = '#ffffff') {
    const a = Math.max(0, Math.min(1, alpha));
    const fg = hexToRgb(foregroundHex);
    const bg = hexToRgb(backgroundHex);
    const r = clampByte(fg.r * a + bg.r * (1 - a));
    const g = clampByte(fg.g * a + bg.g * (1 - a));
    const b = clampByte(fg.b * a + bg.b * (1 - a));
    return `rgb(${r}, ${g}, ${b})`;
}
//# sourceMappingURL=alphaBlendHex.js.map